//--------------------------------------------------
// Initialise some JS action

document.createElement('picture');
document.getElementsByTagName('body')[0].className = document
  .getElementsByTagName('body')[0]
  .className.replace('js-disabled', 'js-enabled');
